// ============================================================
// App Entry Point
// ============================================================
// RouterProvider is a data router and creates its own React tree.
// Context providers that need to be consumed by route components
// are placed inside a root layout route instead.

import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { lightTheme, tokens } from '@/theme';
import { queryClient } from '@/api/queryClient';
import { NoInternetModal } from '@/components/feedback/NoInternetModal';
import { ErrorBoundary } from './ErrorBoundary';
import router from '@/router';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={lightTheme}>
          <CssBaseline />
          <RouterProvider router={router} />
          <NoInternetModal />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                borderRadius: tokens.radius.md,
                fontSize: tokens.typography.sizes.body,
                boxShadow: tokens.shadows.dropdown,
                border: `1px solid ${tokens.colors.border}`,
                padding: '12px 16px',
              },
              success: {
                iconTheme: {
                  primary: tokens.colors.success.main,
                  secondary: '#fff',
                },
              },
              error: {
                iconTheme: {
                  primary: tokens.colors.error.main,
                  secondary: '#fff',
                },
              },
            }}
          />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
